import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { keys } from './constants';

const DiscardRefundDialog = ({ open, translate, onConfirm, onCancel }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs">
    <DialogTitle>{translate(keys.discardTitle)}</DialogTitle>
    <DialogContent>
      <DialogContentText component="div">{translate(keys.discardBody)}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button id="refundByItem-discard-cancel-button" onClick={onCancel}>
        {translate(keys.keepEditing)}
      </Button>
      <Button id="refundByItem-discard-confirm-button" onClick={onConfirm} color="secondary" variant="contained">
        {translate(keys.discard)}
      </Button>
    </DialogActions>
  </Dialog>
);

DiscardRefundDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default DiscardRefundDialog;
